import { useAuthStore } from "~/store/auth";

// noinspection JSUnusedGlobalSymbols
export default defineNuxtRouteMiddleware(async () => {
	const { $client } = useNuxtApp();
	const authStore = useAuthStore();
	const { user, userAccount } = await $client.rpcAuth.currentUser.query();
	if (user) {
		authStore.setUser(user);
		authStore.setPin(user.pin);
		authStore.coins = Number(await $client.rPayment.getCoins.query());
		authStore.activeSub =
			await $client.rSubscription.currentSubscription.query();
	}
	if (userAccount) {
		authStore.setUserAccount(userAccount);
	}
});
